import React, { useEffect, useState } from "react";
import { collection, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import { Db } from "./../../firebase";

import TopNewsSection from "../../Compments/TopNewsSection";
import NewsSection from "../../Compments/newsSection";
import ReviewSection from "../../Compments/ReviewSection";
import InterviewsSection from "../../Compments/InterviewsSection";
import DailyColumnSection from "../../Compments/DailyColumn";
import FromThePitSection from "../../Compments/FromThePit";
import "./Pages.css";

const Home = () => {
  const [topNews, setTopNews] = useState([]);
  const [news, setNews] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [dailyColumnsMap, setDailyColumnsMap] = useState({});
  const [specialProjects, setSpecialProjects] = useState([]);

  useEffect(() => {
    // 🔹 1. Top News
    const q1 = query(
      collection(Db, "posts"),
      where("status", "==", "published"),
      where("category", "==", "topnews"),
      orderBy("createdAt", "desc"),
      limit(5)
    );
    const unsub1 = onSnapshot(q1, (snapshot) => {
      setTopNews(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    // 🔹 2. News
    const q2 = query(
      collection(Db, "posts"),
      where("status", "==", "published"),
      where("category", "==", "news"),
      orderBy("createdAt", "desc"),
      limit(6)
    );
    const unsub2 = onSnapshot(q2, (snapshot) => {
      setNews(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    // 🔹 3. Reviews
    const q3 = query(
      collection(Db, "posts"),
      where("status", "==", "published"),
      where("category", "==", "reviews"),
      orderBy("createdAt", "desc"),
      limit(6)
    );
    const unsub3 = onSnapshot(q3, (snapshot) => {
      setReviews(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    // 🔹 4. Interviews
    const q4 = query(
      collection(Db, "posts"),
      where("status", "==", "published"),
      where("category", "==", "interviews"),
      orderBy("createdAt", "desc"),
      limit(6)
    );
    const unsub4 = onSnapshot(q4, (snapshot) => {
      setInterviews(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    // 🔹 5. Special Projects
    const q5 = query(
      collection(Db, "posts"),
      where("status", "==", "published"),
      where("category", "==", "specialprojects"),
      orderBy("createdAt", "desc"),
      limit(4)
    );
    const unsub5 = onSnapshot(q5, (snapshot) => {
      setSpecialProjects(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });

    // 🔹 6. Daily Columns
    const q6 = query(
      collection(Db, "posts"),
      where("status", "==", "published"),
      where("category", "==", "dailycolumn"),
      orderBy("createdAt", "desc"),
      limit(20)
    );
    const unsub6 = onSnapshot(q6, (snapshot) => {
      const dailyColumnData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      const newColumnsMap = {};
      const uniqueColumnNames = new Set();

      dailyColumnData.forEach((article) => {
        const name = article.columnName;
        if (name && !uniqueColumnNames.has(name)) {
          newColumnsMap[name] = [article];
          uniqueColumnNames.add(name);
        }
      });

      setDailyColumnsMap(newColumnsMap);
    });

    // 🔹 Cleanup όλων των listeners
    return () => {
      unsub1();
      unsub2();
      unsub3();
      unsub4();
      unsub5();
      unsub6();
    };
  }, []);

  return (
    <>
      {/* SECTION 1: TOP NEWS */}
      <TopNewsSection articles={topNews} />

      {/* SECTION 2: NEWS */}
      <NewsSection news={news} />

      {/* SECTION 3: REVIEWS */}
      <ReviewSection reviews={reviews} />

      {/* SECTION 4: INTERVIEWS */}
      <InterviewsSection interviews={interviews} />

      {/* SECTION 5: DAILY COLUMNS */}
      {Object.entries(dailyColumnsMap).map(([columnTitle, articles]) => (
        <DailyColumnSection
          key={columnTitle}
          articles={articles}
          title={columnTitle}
        />
      ))}

      {/* SECTION 7: FROM THE PIT */}
      <FromThePitSection />
    </>
  );
};

export default Home;
